import React from 'react';
import {ICountDownTimerProps} from '@dazn/lp-web/src/types';
import styles from './countdown.module.css';
import {ColonIcon} from '../Icons';

const variantStyles = {
    V1: {
        countdownTimerContainer: styles.countdownTimerContainer,
        countdownTimeBox: styles.countdownTimeBox,
        countdownTimer: styles.countdownTimer,
        countdownUnits: styles.countdownUnits
    },
    V2: {
        countdownTimerContainer: styles.countdownTimerContainerV2,
        countdownTimeBox: styles.countdownTimeBoxV2,
        countdownTimer: styles.countdownTimerV2,
        countdownUnits: styles.countdownUnitsV2
    }
};

export const CountdownTimer: React.FC<ICountDownTimerProps> = ({
    hideCountdownZero,
    timer,
    units,
    variant = 'V1'
}) => {
    const unitsArr = units.split(',') || [];
    if (!timer || (timer && timer.isTimerEnded)) return null;
    const {
        countdownTimerContainer,
        countdownTimeBox,
        countdownTimer,
        countdownUnits
    } = variantStyles[variant] || variantStyles.V1;

    return (
        <div id="countdown-timer" className={countdownTimerContainer}>
            {Object.entries(timer).map(([unit, value], index) => {
                if (
                    unit === 'isTimerEnded' ||
                    (hideCountdownZero && value === '00')
                ) {
                    return null;
                }
                const unitLabel = unitsArr[index] || '';
                const isLastVisibleUnit =
                    index === Object.entries(timer).length - 2;
                const shouldShowColon = variant === 'V2' && !isLastVisibleUnit;

                return (
                    <React.Fragment key={unit}>
                        <div className={countdownTimeBox}>
                            <div className={countdownTimer}>{value}</div>
                            <div className={countdownUnits}>{unitLabel}</div>
                        </div>
                        {shouldShowColon && <ColonIcon />}
                    </React.Fragment>
                );
            })}
        </div>
    );
};
